<div class="tt-w-instant-answers">
  <tt-user-toolbar></tt-user-toolbar>
  <tt-ask v-model="questionText"
          :inAskMode="inAskMode" 
          :errorText="errorText"
          :countText="countText"></tt-ask>
  <div class="tt-c-ask-results" :class="{'tt-c-ask-results--on': showResultsContent}">
    <div class="tt-c-ask-results__meta">
      <tt-button v-if="detailItem" 
        type="secondary"
        class="tt-c-ask-results__back-btn"
        @click="backToResults">
        <tt-icon name="caret-left" size="sm"></tt-icon><span v-html="$msg('askResults.back')"></span>
      </tt-button>
      <div v-show="!detailItem && isSearching" class="tt-o-spinner tt-c-ask-results__spinner"></div>
        <div ref="resultsCount"
           class="tt-c-ask-results__text"
           aria-live="polite"
           tabindex="-1"
           v-html="resultsCountText"></div>
        <div v-if="showResultsContent" class="tt-c-instant-answers__submit-wrap">
          <span class="tt-c-instant-answers__results-prompt tt-u-hide-until--md" v-html="resultsPromptText"></span>
          <tt-button type="primary" class="tt-c-instant-answers__submit-question" @click="enterAskMode"><span v-html="$msg('ia.results.submitNew')"></span><tt-icon name="caret-right" size="sm"></tt-icon></tt-button>
        </div>
      </div>
    <tt-ask-results-content v-if="showResultsContent"
                            :detailItem="detailItem"
                            :detailItemType="detailItemType"
                            :searchResults="searchResults"
                            :searchTerm="questionText"
                            @itemClick="onInstantAnswerClick"
                            @detailItemChange="onDetailItemChange"
                            @pageChange="onPageChange"
                            @showError="onShowError"></tt-ask-results-content>
  </div>
  <tt-multi-items v-if="showMultiItems" :multiItems="multiItems" :promptText="multiItemsPromptText" :sku="currentSku" @addItems="addMultiItems" @removeItem="removeMultiItem"></tt-multi-items>
  <div v-if="inAskMode" class="tt-c-instant-answers__action-buttons tt-o-button-group">
    <div v-show="isSubmitting" class="tt-o-spinner tt-o-spinner--submit"></div>
    <tt-button v-if="!isSubmitting" ref="submitBtn" type="primary" @click="submitQuestion" class="tt-c-instant-answers__submit" v-html="$msg('ia.submit')"></tt-button>
    <tt-button type="secondary" @click="cancelAskMode" class="tt-c-instant-answers__cancel" :disabled="isSubmitting" v-html="$msg('ia.cancel')"></tt-button>
  </div>
</div>